import { Link, useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from "axios";
import Swal from 'sweetalert2';

const validationSchema = yup.object({
    email: yup
      .string('Enter your email')
      .email('Enter a valid email')
      .required('Email is required')
});
export default function ForgotPassword() {
    const navigate = useNavigate();
    const initialValues = {
        email: ''
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);  
            formik.resetForm();           
        }
    });
    const handleSubmit = (values) => {
        axios.post('/api/users/forgotpassword', values).then((res) =>{
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                    navigate("/")                 
                })                
            }
            else{
                Swal.fire(res.data.message, '', 'info')
            }
        }).catch((error) => {
            Swal.fire(error.message, '', 'info')        
        });
    }

    return (
        <section>
            <div className="authentication-wrapper authentication-cover">
                <div className="authentication-inner row m-0">
                
                    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                        <div className="w-100 d-flex justify-content-center">
                            <img src="assets/img/login-image.png" className="img-fluid login-wallpaper" alt="Login image" />
                        </div>
                    </div>
                
                    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                        <div className="w-px-400 mx-auto">
                        
                            <div className="app-brand mb-4">
                                <a href="dashboard.php" className="app-brand-link gap-2">
                                    {/* <img src="assets/img/first-feedback-logo.png" alt="" height="55px"/> */}
                                    <img src={process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo.png"} alt=""  />
                                </a>
                            </div>               
                            <h4 className="mb-2">Forgot Password? 🔒</h4>
                            <p className="mb-4">Enter your email and we'll send you instructions to reset your password</p>
                            <form id="formAuthentication" className="mb-3" onSubmit={formik.handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input type="text" className="form-control" id="email" name="email" placeholder="Enter your email" autoFocus onChange={formik.handleChange}  onBlur={formik.handleChange} value={formik.values.email}/>
                                </div>                                
                                {formik.touched.email && formik.errors.email && (
                                    <div className='text-danger fs-13 mb-3'>{formik.errors.email}</div>
                                )}
                                <button type='submit' className="btn btn-primary d-grid w-100">Submit</button>
                            </form>
                            <div>
                                <Link to="/" className="d-flex align-items-center justify-content-center">
                                    <i className="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                                    Back to login
                                </Link>
                            </div>

                        </div>
                    </div>        
                </div>
            </div>
        </section>
    )
}